import { render, staticRenderFns } from "./voiceEditType.vue?vue&type=template&id=1a10188f&scoped=true&"
import script from "./voiceEditType.vue?vue&type=script&lang=js&"
export * from "./voiceEditType.vue?vue&type=script&lang=js&"
import style0 from "./voiceEditType.vue?vue&type=style&index=0&id=1a10188f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a10188f",
  null
  
)

component.options.__file = "voiceEditType.vue"
export default component.exports